import Card, { CardProps } from 'antd/lib/card';
import React, { ReactElement } from 'react';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import './Panel.less';

interface IPanel extends CardProps {
  header?: string;
  guttor?: number;
}

const Panel = (props: IPanel): ReactElement => {
  return (
    <Card
      {...props} className={'panel-styles ' + props.className}
      style={{ marginBottom: props.guttor ? props.guttor : GUTTOR_SPACE }}
      bodyStyle={props.bodyStyle}>
      {props.children}
    </Card>
  );
};

export default Panel;
